<template>
  <div class="">
    <h4 class="text-center">Settings</h4>
    <!-- Automatic Sending Interval -->
    <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
      <label v-if="isSavable" for="sending_interval[]">Automatic Sending Interval</label>
        <label v-else for="sending_interval[]">Reporting Interval</label>
      <select2 id="sending_interval[]"
              :options="intervals"
               v-model:value="$data._interval"
               :close-on-select="true"
      ></select2>
    </div>

    <!-- Day of week to send -->
    <div    v-if="permissions.can('manage_detailed_alarm_report')
                              && interval === 'weekly' && isSavable"
            class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
      <label for="day_of_week[]">Day of Week to Send Report</label>
      <select2 id="day_of_week[]"
               :options="weekdayOptions"
               v-model:value="$data._settings['weekday']"
               :close-on-select="true"
               @input="updateSettings($event, 'weekday')"
      ></select2>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
      <label for="offlineDevices">Show Offline Devices in Report</label>
      <toggle
          id="offlineDevices"
          name="offlineDevices"
          v-model:value="$data._settings['show_offline']"
          @toggle="updateSettings($event, 'show_offline')">
      </toggle>
    </div>

  </div>

</template>

<script>
import axios from "axios"

import DateTimePicker from "@/components/Reports/VueDatePicker";

import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

import Select2 from "@/components/elements/select2";
import Toggle from "@/components/elements/toggle.vue";

const INTERVALS = {
  daily: 'Daily',
  weekly: 'Weekly',
  'semi-monthly': 'Semi-Monthly',
  monthly: 'Monthly',
}

const WEEKDAY_OPTIONS = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
}

const SEMI_MONTH_OPTIONS = {
  first: '1st Half (1 - 15)',
  last: '2nd Half (16 - End of Month)',
}

export default {
  name: "WeeklyDeviceSummaryReportSettings",
  mixins: [SonicuCoreMixin],
  components: {Toggle, Select2, DateTimePicker},
  props:{
    settings: Object,
    receiveWeekday: {
      type: Number,
      default: 1,
    },
    semiMonthHalf: {
      type: String,
      default: 'first',
    },
    // TODO. include this in JS instead
    weekdayOptions: {
      type: Object,
      default: WEEKDAY_OPTIONS,
    },
    semiMonthOptions: {
      type: Object,
      default: SEMI_MONTH_OPTIONS,
    },
    intervals: {
      type: Object,
      default: INTERVALS,
    },
    interval: {
      type: String,
      default: 'weekly',
    },
    isSavable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      report_formats: ["View PDF", "View as a Webpage"],
      _selected_format: null,
      _interval: this.interval,
      _settings: this.settings,
    }
  },
  created() {
  },
  mounted() {
      if (! _.has(this.$data._settings, 'weekday')) {
          this.$data._settings['weekday'] = 1
      }
  },
  methods: {
      updateSettings(event, triggeringComponent = 'Unknown') {
          // Update the settings values based on the new local
          this.$emit('update:settings', this.$data._settings)
          this.$forceUpdate()
      },
    saveSettings() {
      this.$emit(`saveSettings`)
    },
  },
  computed: {},
  watch: {
    _interval(val, old) {
      if (val !== old) {
        this.$emit('update:interval', this.$data._interval)
      }
    },
  },
}
</script>

<style scoped>

</style>